import { DaylightCommonContent } from "../../../../modules/content/components/DaylightCommonContent/DaylightCommonContent";
import { DaylightSection } from "../../../../modules/content/components/DaylightSection/DaylightSection";
import type { ISimpleHeroBlockProps } from "./SimpleHeroBlock.props";

export const SimpleHeroBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  parentClass,
  spacing,
}: ISimpleHeroBlockProps) => {
  if (!eyebrow && !heading && !description && !buttons?.length) return null;

  return (
    <DaylightSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="daylight-work-surface relative isolate flex min-h-[28rem] items-end overflow-hidden rounded-[28px] px-7 py-12 text-ink md:px-14 md:py-16 lg:px-20 lg:py-20">
        <DaylightCommonContent
          alignment={alignment}
          buttons={buttons}
          className="relative z-10"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
          headingAs="h1"
          headingClassName="max-w-[12ch] text-[clamp(3rem,7vw,5.125rem)] leading-[0.98]"
          tone="light"
        />
      </div>
    </DaylightSection>
  );
};

SimpleHeroBlock.displayName = "Block::SimpleHeroBlock";
